import { render, staticRenderFns } from "./SchemaPopup.vue?vue&type=template&id=39b48a42&scoped=true&"
import script from "./SchemaPopup.vue?vue&type=script&lang=js&"
export * from "./SchemaPopup.vue?vue&type=script&lang=js&"
import style0 from "./SchemaPopup.vue?vue&type=style&index=0&id=39b48a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b48a42",
  null
  
)

export default component.exports